import { TrashIcon, ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

const DeletedEventMessage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center p-8 max-w-md bg-white rounded-lg shadow-lg">
        <div className="mb-6 text-red-600">
          <TrashIcon className="w-16 h-16 mx-auto" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Event Unavailable</h2>
        <p className="text-gray-600 mb-6">This event has been removed by the organizer.</p>
        <button
          onClick={() => navigate("/")}
          className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
        >
          <ArrowTopRightOnSquareIcon className="w-5 h-5" />
          Return to Homepage
        </button>
      </div>
    </div>
  );
};
export default DeletedEventMessage
